/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OauthSuccessRouteImport } from './routes/oauth-success'
import { Route as MagicLinkRouteImport } from './routes/magic-link'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OnboardingUserRouteImport } from './routes/onboarding/user'
import { Route as OnboardingOrganizationRouteImport } from './routes/onboarding/organization'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AppStartTrialRouteImport } from './routes/_app/start-trial'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppCrmRouteImport } from './routes/_app/crm'
import { Route as AppChatRouteImport } from './routes/_app/chat'
import { Route as AppBillingSuspendedRouteImport } from './routes/_app/billing-suspended'
import { Route as OnboardingOrganizationIndexRouteImport } from './routes/onboarding/organization.index'
import { Route as AppSettingsTeamRouteImport } from './routes/_app/_settings/team'
import { Route as AppSettingsStaffRouteImport } from './routes/_app/_settings/staff'
import { Route as AppSettingsServicesRouteImport } from './routes/_app/_settings/services'
import { Route as AppSettingsPaymentsRouteImport } from './routes/_app/_settings/payments'
import { Route as AppSettingsOrganizationRouteImport } from './routes/_app/_settings/organization'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/_settings/notifications'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/_settings/integrations'
import { Route as AppSettingsFormsRouteImport } from './routes/_app/_settings/forms'
import { Route as AppSettingsEmailSuppressionsRouteImport } from './routes/_app/_settings/email-suppressions'
import { Route as AppSettingsEmailRouteImport } from './routes/_app/_settings/email'
import { Route as AppSettingsDisputesRouteImport } from './routes/_app/_settings/disputes'
import { Route as AppSettingsCompanyRouteImport } from './routes/_app/_settings/company'
import { Route as AppSettingsCommunicationsRouteImport } from './routes/_app/_settings/communications'
import { Route as AppSettingsClientPortalRouteImport } from './routes/_app/_settings/client-portal'
import { Route as AppSettingsAttachmentLibraryRouteImport } from './routes/_app/_settings/attachment-library'
import { Route as AppHomeTasksRouteImport } from './routes/_app/_home/tasks'
import { Route as AppHomeSalesTaxRouteImport } from './routes/_app/_home/sales-tax'
import { Route as AppHomeRevenueRouteImport } from './routes/_app/_home/revenue'
import { Route as AppHomeReportsRouteImport } from './routes/_app/_home/reports'
import { Route as AppHomeLeadsRouteImport } from './routes/_app/_home/leads'
import { Route as AppHomeInboxRouteImport } from './routes/_app/_home/inbox'
import { Route as AppHomeFeedbackRouteImport } from './routes/_app/_home/feedback'
import { Route as AppHomeDashboardRouteImport } from './routes/_app/_home/dashboard'
import { Route as AppHomeCalendarRouteImport } from './routes/_app/_home/calendar'
import { Route as AppCrmMarketingRouteImport } from './routes/_app/_crm/marketing'
import { Route as AppSettingsWorkflowsIndexRouteImport } from './routes/_app/settings_/workflows/index'
import { Route as AppHomeWorkflowsIndexRouteImport } from './routes/_app/_home/workflows/index'
import { Route as AppHomeQuotesIndexRouteImport } from './routes/_app/_home/quotes/index'
import { Route as AppHomePipelineIndexRouteImport } from './routes/_app/_home/pipeline/index'
import { Route as AppHomeLeadsIndexRouteImport } from './routes/_app/_home/leads/index'
import { Route as AppHomeInvoicesIndexRouteImport } from './routes/_app/_home/invoices/index'
import { Route as AppHomeEventsIndexRouteImport } from './routes/_app/_home/events/index'
import { Route as AppCrmContactsIndexRouteImport } from './routes/_app/_crm/contacts/index'
import { Route as AppCrmCompaniesIndexRouteImport } from './routes/_app/_crm/companies/index'
import { Route as OnboardingOrganizationGroupStepRouteImport } from './routes/onboarding/organization.$group.$step'
import { Route as AppSettingsWorkflowsNewRouteImport } from './routes/_app/settings_/workflows/new'
import { Route as AppSettingsWorkflowsIdRouteImport } from './routes/_app/settings_/workflows/$id'
import { Route as AppHomeQuotesNewRouteImport } from './routes/_app/_home/quotes/new'
import { Route as AppHomeQuotesIdRouteImport } from './routes/_app/_home/quotes/$id'
import { Route as AppHomePipelineIdRouteImport } from './routes/_app/_home/pipeline/$id'
import { Route as AppHomeLeadsIdRouteImport } from './routes/_app/_home/leads/$id'
import { Route as AppHomeInvoicesNewRouteImport } from './routes/_app/_home/invoices/new'
import { Route as AppHomeInvoicesIdRouteImport } from './routes/_app/_home/invoices/$id'
import { Route as AppHomeEventsIdRouteImport } from './routes/_app/_home/events/$id'
import { Route as AppCrmContactsIdRouteImport } from './routes/_app/_crm/contacts/$id'
import { Route as AppCrmCompaniesNewRouteImport } from './routes/_app/_crm/companies/new'
import { Route as AppCrmCompaniesIdRouteImport } from './routes/_app/_crm/companies/$id'
import { Route as AppSettingsWorkflowsIdIndexRouteImport } from './routes/_app/settings_/workflows/$id/index'
import { Route as AppSettingsWorkflowsIdEditRouteImport } from './routes/_app/settings_/workflows/$id/edit'
import { Route as AppHomePipelineIdQuotesQuoteIdRouteImport } from './routes/_app/_home/pipeline/$id_.quotes.$quoteId'
import { Route as AppHomePipelineIdLeadsLeadIdRouteImport } from './routes/_app/_home/pipeline/$id_.leads.$leadId'
import { Route as AppHomePipelineIdInvoicesInvoiceIdRouteImport } from './routes/_app/_home/pipeline/$id_.invoices.$invoiceId'
import { Route as AppHomePipelineIdEventsEventIdRouteImport } from './routes/_app/_home/pipeline/$id_.events.$eventId'
import { Route as AppHomePipelineIdEventsEventIdRunSheetRouteImport } from './routes/_app/_home/pipeline/$id_.events.$eventId_.run-sheet'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthSuccessRoute = OauthSuccessRouteImport.update({
  id: '/oauth-success',
  path: '/oauth-success',
  getParentRoute: () => rootRouteImport,
} as any)
const MagicLinkRoute = MagicLinkRouteImport.update({
  id: '/magic-link',
  path: '/magic-link',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingUserRoute = OnboardingUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingOrganizationRoute = OnboardingOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => OnboardingRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppStartTrialRoute = AppStartTrialRouteImport.update({
  id: '/start-trial',
  path: '/start-trial',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmRoute = AppCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingSuspendedRoute = AppBillingSuspendedRouteImport.update({
  id: '/billing-suspended',
  path: '/billing-suspended',
  getParentRoute: () => AppRoute,
} as any)
const OnboardingOrganizationIndexRoute =
  OnboardingOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OnboardingOrganizationRoute,
  } as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: '/_settings/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsStaffRoute = AppSettingsStaffRouteImport.update({
  id: '/_settings/staff',
  path: '/staff',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsServicesRoute = AppSettingsServicesRouteImport.update({
  id: '/_settings/services',
  path: '/services',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsPaymentsRoute = AppSettingsPaymentsRouteImport.update({
  id: '/_settings/payments',
  path: '/payments',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsOrganizationRoute = AppSettingsOrganizationRouteImport.update({
  id: '/_settings/organization',
  path: '/organization',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/_settings/notifications',
    path: '/notifications',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/_settings/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsFormsRoute = AppSettingsFormsRouteImport.update({
  id: '/_settings/forms',
  path: '/forms',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsEmailSuppressionsRoute =
  AppSettingsEmailSuppressionsRouteImport.update({
    id: '/_settings/email-suppressions',
    path: '/email-suppressions',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsEmailRoute = AppSettingsEmailRouteImport.update({
  id: '/_settings/email',
  path: '/email',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsDisputesRoute = AppSettingsDisputesRouteImport.update({
  id: '/_settings/disputes',
  path: '/disputes',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCompanyRoute = AppSettingsCompanyRouteImport.update({
  id: '/_settings/company',
  path: '/company',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCommunicationsRoute =
  AppSettingsCommunicationsRouteImport.update({
    id: '/_settings/communications',
    path: '/communications',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsClientPortalRoute = AppSettingsClientPortalRouteImport.update({
  id: '/_settings/client-portal',
  path: '/client-portal',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAttachmentLibraryRoute =
  AppSettingsAttachmentLibraryRouteImport.update({
    id: '/_settings/attachment-library',
    path: '/attachment-library',
    getParentRoute: () => AppRoute,
  } as any)
const AppHomeTasksRoute = AppHomeTasksRouteImport.update({
  id: '/_home/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeSalesTaxRoute = AppHomeSalesTaxRouteImport.update({
  id: '/_home/sales-tax',
  path: '/sales-tax',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRevenueRoute = AppHomeRevenueRouteImport.update({
  id: '/_home/revenue',
  path: '/revenue',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeReportsRoute = AppHomeReportsRouteImport.update({
  id: '/_home/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeLeadsRoute = AppHomeLeadsRouteImport.update({
  id: '/_home/leads',
  path: '/leads',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeInboxRoute = AppHomeInboxRouteImport.update({
  id: '/_home/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeFeedbackRoute = AppHomeFeedbackRouteImport.update({
  id: '/_home/feedback',
  path: '/feedback',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeDashboardRoute = AppHomeDashboardRouteImport.update({
  id: '/_home/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeCalendarRoute = AppHomeCalendarRouteImport.update({
  id: '/_home/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmMarketingRoute = AppCrmMarketingRouteImport.update({
  id: '/_crm/marketing',
  path: '/marketing',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWorkflowsIndexRoute =
  AppSettingsWorkflowsIndexRouteImport.update({
    id: '/settings_/workflows/',
    path: '/settings/workflows/',
    getParentRoute: () => AppRoute,
  } as any)
const AppHomeWorkflowsIndexRoute = AppHomeWorkflowsIndexRouteImport.update({
  id: '/_home/workflows/',
  path: '/workflows/',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeQuotesIndexRoute = AppHomeQuotesIndexRouteImport.update({
  id: '/_home/quotes/',
  path: '/quotes/',
  getParentRoute: () => AppRoute,
} as any)
const AppHomePipelineIndexRoute = AppHomePipelineIndexRouteImport.update({
  id: '/_home/pipeline/',
  path: '/pipeline/',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeLeadsIndexRoute = AppHomeLeadsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppHomeLeadsRoute,
} as any)
const AppHomeInvoicesIndexRoute = AppHomeInvoicesIndexRouteImport.update({
  id: '/_home/invoices/',
  path: '/invoices/',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeEventsIndexRoute = AppHomeEventsIndexRouteImport.update({
  id: '/_home/events/',
  path: '/events/',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmContactsIndexRoute = AppCrmContactsIndexRouteImport.update({
  id: '/_crm/contacts/',
  path: '/contacts/',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmCompaniesIndexRoute = AppCrmCompaniesIndexRouteImport.update({
  id: '/_crm/companies/',
  path: '/companies/',
  getParentRoute: () => AppRoute,
} as any)
const OnboardingOrganizationGroupStepRoute =
  OnboardingOrganizationGroupStepRouteImport.update({
    id: '/$group/$step',
    path: '/$group/$step',
    getParentRoute: () => OnboardingOrganizationRoute,
  } as any)
const AppSettingsWorkflowsNewRoute = AppSettingsWorkflowsNewRouteImport.update({
  id: '/settings_/workflows/new',
  path: '/settings/workflows/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWorkflowsIdRoute = AppSettingsWorkflowsIdRouteImport.update({
  id: '/settings_/workflows/$id',
  path: '/settings/workflows/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeQuotesNewRoute = AppHomeQuotesNewRouteImport.update({
  id: '/_home/quotes/new',
  path: '/quotes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeQuotesIdRoute = AppHomeQuotesIdRouteImport.update({
  id: '/_home/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHomePipelineIdRoute = AppHomePipelineIdRouteImport.update({
  id: '/_home/pipeline/$id',
  path: '/pipeline/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeLeadsIdRoute = AppHomeLeadsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppHomeLeadsRoute,
} as any)
const AppHomeInvoicesNewRoute = AppHomeInvoicesNewRouteImport.update({
  id: '/_home/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeInvoicesIdRoute = AppHomeInvoicesIdRouteImport.update({
  id: '/_home/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeEventsIdRoute = AppHomeEventsIdRouteImport.update({
  id: '/_home/events/$id',
  path: '/events/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmContactsIdRoute = AppCrmContactsIdRouteImport.update({
  id: '/_crm/contacts/$id',
  path: '/contacts/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmCompaniesNewRoute = AppCrmCompaniesNewRouteImport.update({
  id: '/_crm/companies/new',
  path: '/companies/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmCompaniesIdRoute = AppCrmCompaniesIdRouteImport.update({
  id: '/_crm/companies/$id',
  path: '/companies/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWorkflowsIdIndexRoute =
  AppSettingsWorkflowsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsWorkflowsIdRoute,
  } as any)
const AppSettingsWorkflowsIdEditRoute =
  AppSettingsWorkflowsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppSettingsWorkflowsIdRoute,
  } as any)
const AppHomePipelineIdQuotesQuoteIdRoute =
  AppHomePipelineIdQuotesQuoteIdRouteImport.update({
    id: '/_home/pipeline/$id_/quotes/$quoteId',
    path: '/pipeline/$id/quotes/$quoteId',
    getParentRoute: () => AppRoute,
  } as any)
const AppHomePipelineIdLeadsLeadIdRoute =
  AppHomePipelineIdLeadsLeadIdRouteImport.update({
    id: '/_home/pipeline/$id_/leads/$leadId',
    path: '/pipeline/$id/leads/$leadId',
    getParentRoute: () => AppRoute,
  } as any)
const AppHomePipelineIdInvoicesInvoiceIdRoute =
  AppHomePipelineIdInvoicesInvoiceIdRouteImport.update({
    id: '/_home/pipeline/$id_/invoices/$invoiceId',
    path: '/pipeline/$id/invoices/$invoiceId',
    getParentRoute: () => AppRoute,
  } as any)
const AppHomePipelineIdEventsEventIdRoute =
  AppHomePipelineIdEventsEventIdRouteImport.update({
    id: '/_home/pipeline/$id_/events/$eventId',
    path: '/pipeline/$id/events/$eventId',
    getParentRoute: () => AppRoute,
  } as any)
const AppHomePipelineIdEventsEventIdRunSheetRoute =
  AppHomePipelineIdEventsEventIdRunSheetRouteImport.update({
    id: '/_home/pipeline/$id_/events/$eventId_/run-sheet',
    path: '/pipeline/$id/events/$eventId/run-sheet',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/magic-link': typeof MagicLinkRoute
  '/oauth-success': typeof OauthSuccessRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/signup': typeof SignupRoute
  '/billing-suspended': typeof AppBillingSuspendedRoute
  '/chat': typeof AppChatRoute
  '/crm': typeof AppCrmRoute
  '/home': typeof AppHomeRoute
  '/settings': typeof AppSettingsRoute
  '/start-trial': typeof AppStartTrialRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboarding/organization': typeof OnboardingOrganizationRouteWithChildren
  '/onboarding/user': typeof OnboardingUserRoute
  '/marketing': typeof AppCrmMarketingRoute
  '/calendar': typeof AppHomeCalendarRoute
  '/dashboard': typeof AppHomeDashboardRoute
  '/feedback': typeof AppHomeFeedbackRoute
  '/inbox': typeof AppHomeInboxRoute
  '/leads': typeof AppHomeLeadsRouteWithChildren
  '/reports': typeof AppHomeReportsRoute
  '/revenue': typeof AppHomeRevenueRoute
  '/sales-tax': typeof AppHomeSalesTaxRoute
  '/tasks': typeof AppHomeTasksRoute
  '/attachment-library': typeof AppSettingsAttachmentLibraryRoute
  '/client-portal': typeof AppSettingsClientPortalRoute
  '/communications': typeof AppSettingsCommunicationsRoute
  '/company': typeof AppSettingsCompanyRoute
  '/disputes': typeof AppSettingsDisputesRoute
  '/email': typeof AppSettingsEmailRoute
  '/email-suppressions': typeof AppSettingsEmailSuppressionsRoute
  '/forms': typeof AppSettingsFormsRoute
  '/integrations': typeof AppSettingsIntegrationsRoute
  '/notifications': typeof AppSettingsNotificationsRoute
  '/organization': typeof AppSettingsOrganizationRoute
  '/payments': typeof AppSettingsPaymentsRoute
  '/services': typeof AppSettingsServicesRoute
  '/staff': typeof AppSettingsStaffRoute
  '/team': typeof AppSettingsTeamRoute
  '/onboarding/organization/': typeof OnboardingOrganizationIndexRoute
  '/companies/$id': typeof AppCrmCompaniesIdRoute
  '/companies/new': typeof AppCrmCompaniesNewRoute
  '/contacts/$id': typeof AppCrmContactsIdRoute
  '/events/$id': typeof AppHomeEventsIdRoute
  '/invoices/$id': typeof AppHomeInvoicesIdRoute
  '/invoices/new': typeof AppHomeInvoicesNewRoute
  '/leads/$id': typeof AppHomeLeadsIdRoute
  '/pipeline/$id': typeof AppHomePipelineIdRoute
  '/quotes/$id': typeof AppHomeQuotesIdRoute
  '/quotes/new': typeof AppHomeQuotesNewRoute
  '/settings/workflows/$id': typeof AppSettingsWorkflowsIdRouteWithChildren
  '/settings/workflows/new': typeof AppSettingsWorkflowsNewRoute
  '/onboarding/organization/$group/$step': typeof OnboardingOrganizationGroupStepRoute
  '/companies': typeof AppCrmCompaniesIndexRoute
  '/contacts': typeof AppCrmContactsIndexRoute
  '/events': typeof AppHomeEventsIndexRoute
  '/invoices': typeof AppHomeInvoicesIndexRoute
  '/leads/': typeof AppHomeLeadsIndexRoute
  '/pipeline': typeof AppHomePipelineIndexRoute
  '/quotes': typeof AppHomeQuotesIndexRoute
  '/workflows': typeof AppHomeWorkflowsIndexRoute
  '/settings/workflows': typeof AppSettingsWorkflowsIndexRoute
  '/settings/workflows/$id/edit': typeof AppSettingsWorkflowsIdEditRoute
  '/settings/workflows/$id/': typeof AppSettingsWorkflowsIdIndexRoute
  '/pipeline/$id/events/$eventId': typeof AppHomePipelineIdEventsEventIdRoute
  '/pipeline/$id/invoices/$invoiceId': typeof AppHomePipelineIdInvoicesInvoiceIdRoute
  '/pipeline/$id/leads/$leadId': typeof AppHomePipelineIdLeadsLeadIdRoute
  '/pipeline/$id/quotes/$quoteId': typeof AppHomePipelineIdQuotesQuoteIdRoute
  '/pipeline/$id/events/$eventId/run-sheet': typeof AppHomePipelineIdEventsEventIdRunSheetRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/magic-link': typeof MagicLinkRoute
  '/oauth-success': typeof OauthSuccessRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/signup': typeof SignupRoute
  '/billing-suspended': typeof AppBillingSuspendedRoute
  '/chat': typeof AppChatRoute
  '/crm': typeof AppCrmRoute
  '/home': typeof AppHomeRoute
  '/settings': typeof AppSettingsRoute
  '/start-trial': typeof AppStartTrialRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboarding/user': typeof OnboardingUserRoute
  '/marketing': typeof AppCrmMarketingRoute
  '/calendar': typeof AppHomeCalendarRoute
  '/dashboard': typeof AppHomeDashboardRoute
  '/feedback': typeof AppHomeFeedbackRoute
  '/inbox': typeof AppHomeInboxRoute
  '/reports': typeof AppHomeReportsRoute
  '/revenue': typeof AppHomeRevenueRoute
  '/sales-tax': typeof AppHomeSalesTaxRoute
  '/tasks': typeof AppHomeTasksRoute
  '/attachment-library': typeof AppSettingsAttachmentLibraryRoute
  '/client-portal': typeof AppSettingsClientPortalRoute
  '/communications': typeof AppSettingsCommunicationsRoute
  '/company': typeof AppSettingsCompanyRoute
  '/disputes': typeof AppSettingsDisputesRoute
  '/email': typeof AppSettingsEmailRoute
  '/email-suppressions': typeof AppSettingsEmailSuppressionsRoute
  '/forms': typeof AppSettingsFormsRoute
  '/integrations': typeof AppSettingsIntegrationsRoute
  '/notifications': typeof AppSettingsNotificationsRoute
  '/organization': typeof AppSettingsOrganizationRoute
  '/payments': typeof AppSettingsPaymentsRoute
  '/services': typeof AppSettingsServicesRoute
  '/staff': typeof AppSettingsStaffRoute
  '/team': typeof AppSettingsTeamRoute
  '/onboarding/organization': typeof OnboardingOrganizationIndexRoute
  '/companies/$id': typeof AppCrmCompaniesIdRoute
  '/companies/new': typeof AppCrmCompaniesNewRoute
  '/contacts/$id': typeof AppCrmContactsIdRoute
  '/events/$id': typeof AppHomeEventsIdRoute
  '/invoices/$id': typeof AppHomeInvoicesIdRoute
  '/invoices/new': typeof AppHomeInvoicesNewRoute
  '/leads/$id': typeof AppHomeLeadsIdRoute
  '/pipeline/$id': typeof AppHomePipelineIdRoute
  '/quotes/$id': typeof AppHomeQuotesIdRoute
  '/quotes/new': typeof AppHomeQuotesNewRoute
  '/settings/workflows/new': typeof AppSettingsWorkflowsNewRoute
  '/onboarding/organization/$group/$step': typeof OnboardingOrganizationGroupStepRoute
  '/companies': typeof AppCrmCompaniesIndexRoute
  '/contacts': typeof AppCrmContactsIndexRoute
  '/events': typeof AppHomeEventsIndexRoute
  '/invoices': typeof AppHomeInvoicesIndexRoute
  '/leads': typeof AppHomeLeadsIndexRoute
  '/pipeline': typeof AppHomePipelineIndexRoute
  '/quotes': typeof AppHomeQuotesIndexRoute
  '/workflows': typeof AppHomeWorkflowsIndexRoute
  '/settings/workflows': typeof AppSettingsWorkflowsIndexRoute
  '/settings/workflows/$id/edit': typeof AppSettingsWorkflowsIdEditRoute
  '/settings/workflows/$id': typeof AppSettingsWorkflowsIdIndexRoute
  '/pipeline/$id/events/$eventId': typeof AppHomePipelineIdEventsEventIdRoute
  '/pipeline/$id/invoices/$invoiceId': typeof AppHomePipelineIdInvoicesInvoiceIdRoute
  '/pipeline/$id/leads/$leadId': typeof AppHomePipelineIdLeadsLeadIdRoute
  '/pipeline/$id/quotes/$quoteId': typeof AppHomePipelineIdQuotesQuoteIdRoute
  '/pipeline/$id/events/$eventId/run-sheet': typeof AppHomePipelineIdEventsEventIdRunSheetRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/magic-link': typeof MagicLinkRoute
  '/oauth-success': typeof OauthSuccessRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/signup': typeof SignupRoute
  '/_app/billing-suspended': typeof AppBillingSuspendedRoute
  '/_app/chat': typeof AppChatRoute
  '/_app/crm': typeof AppCrmRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/start-trial': typeof AppStartTrialRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboarding/organization': typeof OnboardingOrganizationRouteWithChildren
  '/onboarding/user': typeof OnboardingUserRoute
  '/_app/_crm/marketing': typeof AppCrmMarketingRoute
  '/_app/_home/calendar': typeof AppHomeCalendarRoute
  '/_app/_home/dashboard': typeof AppHomeDashboardRoute
  '/_app/_home/feedback': typeof AppHomeFeedbackRoute
  '/_app/_home/inbox': typeof AppHomeInboxRoute
  '/_app/_home/leads': typeof AppHomeLeadsRouteWithChildren
  '/_app/_home/reports': typeof AppHomeReportsRoute
  '/_app/_home/revenue': typeof AppHomeRevenueRoute
  '/_app/_home/sales-tax': typeof AppHomeSalesTaxRoute
  '/_app/_home/tasks': typeof AppHomeTasksRoute
  '/_app/_settings/attachment-library': typeof AppSettingsAttachmentLibraryRoute
  '/_app/_settings/client-portal': typeof AppSettingsClientPortalRoute
  '/_app/_settings/communications': typeof AppSettingsCommunicationsRoute
  '/_app/_settings/company': typeof AppSettingsCompanyRoute
  '/_app/_settings/disputes': typeof AppSettingsDisputesRoute
  '/_app/_settings/email': typeof AppSettingsEmailRoute
  '/_app/_settings/email-suppressions': typeof AppSettingsEmailSuppressionsRoute
  '/_app/_settings/forms': typeof AppSettingsFormsRoute
  '/_app/_settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/_settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/_settings/organization': typeof AppSettingsOrganizationRoute
  '/_app/_settings/payments': typeof AppSettingsPaymentsRoute
  '/_app/_settings/services': typeof AppSettingsServicesRoute
  '/_app/_settings/staff': typeof AppSettingsStaffRoute
  '/_app/_settings/team': typeof AppSettingsTeamRoute
  '/onboarding/organization/': typeof OnboardingOrganizationIndexRoute
  '/_app/_crm/companies/$id': typeof AppCrmCompaniesIdRoute
  '/_app/_crm/companies/new': typeof AppCrmCompaniesNewRoute
  '/_app/_crm/contacts/$id': typeof AppCrmContactsIdRoute
  '/_app/_home/events/$id': typeof AppHomeEventsIdRoute
  '/_app/_home/invoices/$id': typeof AppHomeInvoicesIdRoute
  '/_app/_home/invoices/new': typeof AppHomeInvoicesNewRoute
  '/_app/_home/leads/$id': typeof AppHomeLeadsIdRoute
  '/_app/_home/pipeline/$id': typeof AppHomePipelineIdRoute
  '/_app/_home/quotes/$id': typeof AppHomeQuotesIdRoute
  '/_app/_home/quotes/new': typeof AppHomeQuotesNewRoute
  '/_app/settings_/workflows/$id': typeof AppSettingsWorkflowsIdRouteWithChildren
  '/_app/settings_/workflows/new': typeof AppSettingsWorkflowsNewRoute
  '/onboarding/organization/$group/$step': typeof OnboardingOrganizationGroupStepRoute
  '/_app/_crm/companies/': typeof AppCrmCompaniesIndexRoute
  '/_app/_crm/contacts/': typeof AppCrmContactsIndexRoute
  '/_app/_home/events/': typeof AppHomeEventsIndexRoute
  '/_app/_home/invoices/': typeof AppHomeInvoicesIndexRoute
  '/_app/_home/leads/': typeof AppHomeLeadsIndexRoute
  '/_app/_home/pipeline/': typeof AppHomePipelineIndexRoute
  '/_app/_home/quotes/': typeof AppHomeQuotesIndexRoute
  '/_app/_home/workflows/': typeof AppHomeWorkflowsIndexRoute
  '/_app/settings_/workflows/': typeof AppSettingsWorkflowsIndexRoute
  '/_app/settings_/workflows/$id/edit': typeof AppSettingsWorkflowsIdEditRoute
  '/_app/settings_/workflows/$id/': typeof AppSettingsWorkflowsIdIndexRoute
  '/_app/_home/pipeline/$id_/events/$eventId': typeof AppHomePipelineIdEventsEventIdRoute
  '/_app/_home/pipeline/$id_/invoices/$invoiceId': typeof AppHomePipelineIdInvoicesInvoiceIdRoute
  '/_app/_home/pipeline/$id_/leads/$leadId': typeof AppHomePipelineIdLeadsLeadIdRoute
  '/_app/_home/pipeline/$id_/quotes/$quoteId': typeof AppHomePipelineIdQuotesQuoteIdRoute
  '/_app/_home/pipeline/$id_/events/$eventId_/run-sheet': typeof AppHomePipelineIdEventsEventIdRunSheetRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/magic-link'
    | '/oauth-success'
    | '/onboarding'
    | '/reset-password'
    | '/set-password'
    | '/signup'
    | '/billing-suspended'
    | '/chat'
    | '/crm'
    | '/home'
    | '/settings'
    | '/start-trial'
    | '/auth/callback'
    | '/oauth/consent'
    | '/onboarding/organization'
    | '/onboarding/user'
    | '/marketing'
    | '/calendar'
    | '/dashboard'
    | '/feedback'
    | '/inbox'
    | '/leads'
    | '/reports'
    | '/revenue'
    | '/sales-tax'
    | '/tasks'
    | '/attachment-library'
    | '/client-portal'
    | '/communications'
    | '/company'
    | '/disputes'
    | '/email'
    | '/email-suppressions'
    | '/forms'
    | '/integrations'
    | '/notifications'
    | '/organization'
    | '/payments'
    | '/services'
    | '/staff'
    | '/team'
    | '/onboarding/organization/'
    | '/companies/$id'
    | '/companies/new'
    | '/contacts/$id'
    | '/events/$id'
    | '/invoices/$id'
    | '/invoices/new'
    | '/leads/$id'
    | '/pipeline/$id'
    | '/quotes/$id'
    | '/quotes/new'
    | '/settings/workflows/$id'
    | '/settings/workflows/new'
    | '/onboarding/organization/$group/$step'
    | '/companies'
    | '/contacts'
    | '/events'
    | '/invoices'
    | '/leads/'
    | '/pipeline'
    | '/quotes'
    | '/workflows'
    | '/settings/workflows'
    | '/settings/workflows/$id/edit'
    | '/settings/workflows/$id/'
    | '/pipeline/$id/events/$eventId'
    | '/pipeline/$id/invoices/$invoiceId'
    | '/pipeline/$id/leads/$leadId'
    | '/pipeline/$id/quotes/$quoteId'
    | '/pipeline/$id/events/$eventId/run-sheet'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/magic-link'
    | '/oauth-success'
    | '/onboarding'
    | '/reset-password'
    | '/set-password'
    | '/signup'
    | '/billing-suspended'
    | '/chat'
    | '/crm'
    | '/home'
    | '/settings'
    | '/start-trial'
    | '/auth/callback'
    | '/oauth/consent'
    | '/onboarding/user'
    | '/marketing'
    | '/calendar'
    | '/dashboard'
    | '/feedback'
    | '/inbox'
    | '/reports'
    | '/revenue'
    | '/sales-tax'
    | '/tasks'
    | '/attachment-library'
    | '/client-portal'
    | '/communications'
    | '/company'
    | '/disputes'
    | '/email'
    | '/email-suppressions'
    | '/forms'
    | '/integrations'
    | '/notifications'
    | '/organization'
    | '/payments'
    | '/services'
    | '/staff'
    | '/team'
    | '/onboarding/organization'
    | '/companies/$id'
    | '/companies/new'
    | '/contacts/$id'
    | '/events/$id'
    | '/invoices/$id'
    | '/invoices/new'
    | '/leads/$id'
    | '/pipeline/$id'
    | '/quotes/$id'
    | '/quotes/new'
    | '/settings/workflows/new'
    | '/onboarding/organization/$group/$step'
    | '/companies'
    | '/contacts'
    | '/events'
    | '/invoices'
    | '/leads'
    | '/pipeline'
    | '/quotes'
    | '/workflows'
    | '/settings/workflows'
    | '/settings/workflows/$id/edit'
    | '/settings/workflows/$id'
    | '/pipeline/$id/events/$eventId'
    | '/pipeline/$id/invoices/$invoiceId'
    | '/pipeline/$id/leads/$leadId'
    | '/pipeline/$id/quotes/$quoteId'
    | '/pipeline/$id/events/$eventId/run-sheet'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/magic-link'
    | '/oauth-success'
    | '/onboarding'
    | '/reset-password'
    | '/set-password'
    | '/signup'
    | '/_app/billing-suspended'
    | '/_app/chat'
    | '/_app/crm'
    | '/_app/home'
    | '/_app/settings'
    | '/_app/start-trial'
    | '/auth/callback'
    | '/oauth/consent'
    | '/onboarding/organization'
    | '/onboarding/user'
    | '/_app/_crm/marketing'
    | '/_app/_home/calendar'
    | '/_app/_home/dashboard'
    | '/_app/_home/feedback'
    | '/_app/_home/inbox'
    | '/_app/_home/leads'
    | '/_app/_home/reports'
    | '/_app/_home/revenue'
    | '/_app/_home/sales-tax'
    | '/_app/_home/tasks'
    | '/_app/_settings/attachment-library'
    | '/_app/_settings/client-portal'
    | '/_app/_settings/communications'
    | '/_app/_settings/company'
    | '/_app/_settings/disputes'
    | '/_app/_settings/email'
    | '/_app/_settings/email-suppressions'
    | '/_app/_settings/forms'
    | '/_app/_settings/integrations'
    | '/_app/_settings/notifications'
    | '/_app/_settings/organization'
    | '/_app/_settings/payments'
    | '/_app/_settings/services'
    | '/_app/_settings/staff'
    | '/_app/_settings/team'
    | '/onboarding/organization/'
    | '/_app/_crm/companies/$id'
    | '/_app/_crm/companies/new'
    | '/_app/_crm/contacts/$id'
    | '/_app/_home/events/$id'
    | '/_app/_home/invoices/$id'
    | '/_app/_home/invoices/new'
    | '/_app/_home/leads/$id'
    | '/_app/_home/pipeline/$id'
    | '/_app/_home/quotes/$id'
    | '/_app/_home/quotes/new'
    | '/_app/settings_/workflows/$id'
    | '/_app/settings_/workflows/new'
    | '/onboarding/organization/$group/$step'
    | '/_app/_crm/companies/'
    | '/_app/_crm/contacts/'
    | '/_app/_home/events/'
    | '/_app/_home/invoices/'
    | '/_app/_home/leads/'
    | '/_app/_home/pipeline/'
    | '/_app/_home/quotes/'
    | '/_app/_home/workflows/'
    | '/_app/settings_/workflows/'
    | '/_app/settings_/workflows/$id/edit'
    | '/_app/settings_/workflows/$id/'
    | '/_app/_home/pipeline/$id_/events/$eventId'
    | '/_app/_home/pipeline/$id_/invoices/$invoiceId'
    | '/_app/_home/pipeline/$id_/leads/$leadId'
    | '/_app/_home/pipeline/$id_/quotes/$quoteId'
    | '/_app/_home/pipeline/$id_/events/$eventId_/run-sheet'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  MagicLinkRoute: typeof MagicLinkRoute
  OauthSuccessRoute: typeof OauthSuccessRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetPasswordRoute: typeof SetPasswordRoute
  SignupRoute: typeof SignupRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  OauthConsentRoute: typeof OauthConsentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth-success': {
      id: '/oauth-success'
      path: '/oauth-success'
      fullPath: '/oauth-success'
      preLoaderRoute: typeof OauthSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/magic-link': {
      id: '/magic-link'
      path: '/magic-link'
      fullPath: '/magic-link'
      preLoaderRoute: typeof MagicLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/user': {
      id: '/onboarding/user'
      path: '/user'
      fullPath: '/onboarding/user'
      preLoaderRoute: typeof OnboardingUserRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/organization': {
      id: '/onboarding/organization'
      path: '/organization'
      fullPath: '/onboarding/organization'
      preLoaderRoute: typeof OnboardingOrganizationRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/start-trial': {
      id: '/_app/start-trial'
      path: '/start-trial'
      fullPath: '/start-trial'
      preLoaderRoute: typeof AppStartTrialRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crm': {
      id: '/_app/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof AppCrmRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing-suspended': {
      id: '/_app/billing-suspended'
      path: '/billing-suspended'
      fullPath: '/billing-suspended'
      preLoaderRoute: typeof AppBillingSuspendedRouteImport
      parentRoute: typeof AppRoute
    }
    '/onboarding/organization/': {
      id: '/onboarding/organization/'
      path: '/'
      fullPath: '/onboarding/organization/'
      preLoaderRoute: typeof OnboardingOrganizationIndexRouteImport
      parentRoute: typeof OnboardingOrganizationRoute
    }
    '/_app/_settings/team': {
      id: '/_app/_settings/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/staff': {
      id: '/_app/_settings/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AppSettingsStaffRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/services': {
      id: '/_app/_settings/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AppSettingsServicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/payments': {
      id: '/_app/_settings/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AppSettingsPaymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/organization': {
      id: '/_app/_settings/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AppSettingsOrganizationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/notifications': {
      id: '/_app/_settings/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/integrations': {
      id: '/_app/_settings/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/forms': {
      id: '/_app/_settings/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AppSettingsFormsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/email-suppressions': {
      id: '/_app/_settings/email-suppressions'
      path: '/email-suppressions'
      fullPath: '/email-suppressions'
      preLoaderRoute: typeof AppSettingsEmailSuppressionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/email': {
      id: '/_app/_settings/email'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof AppSettingsEmailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/disputes': {
      id: '/_app/_settings/disputes'
      path: '/disputes'
      fullPath: '/disputes'
      preLoaderRoute: typeof AppSettingsDisputesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/company': {
      id: '/_app/_settings/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof AppSettingsCompanyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/communications': {
      id: '/_app/_settings/communications'
      path: '/communications'
      fullPath: '/communications'
      preLoaderRoute: typeof AppSettingsCommunicationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/client-portal': {
      id: '/_app/_settings/client-portal'
      path: '/client-portal'
      fullPath: '/client-portal'
      preLoaderRoute: typeof AppSettingsClientPortalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_settings/attachment-library': {
      id: '/_app/_settings/attachment-library'
      path: '/attachment-library'
      fullPath: '/attachment-library'
      preLoaderRoute: typeof AppSettingsAttachmentLibraryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/tasks': {
      id: '/_app/_home/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppHomeTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/sales-tax': {
      id: '/_app/_home/sales-tax'
      path: '/sales-tax'
      fullPath: '/sales-tax'
      preLoaderRoute: typeof AppHomeSalesTaxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/revenue': {
      id: '/_app/_home/revenue'
      path: '/revenue'
      fullPath: '/revenue'
      preLoaderRoute: typeof AppHomeRevenueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/reports': {
      id: '/_app/_home/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppHomeReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/leads': {
      id: '/_app/_home/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AppHomeLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/inbox': {
      id: '/_app/_home/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppHomeInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/feedback': {
      id: '/_app/_home/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AppHomeFeedbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/dashboard': {
      id: '/_app/_home/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppHomeDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/calendar': {
      id: '/_app/_home/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppHomeCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_crm/marketing': {
      id: '/_app/_crm/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof AppCrmMarketingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/workflows/': {
      id: '/_app/settings_/workflows/'
      path: '/settings/workflows'
      fullPath: '/settings/workflows'
      preLoaderRoute: typeof AppSettingsWorkflowsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/workflows/': {
      id: '/_app/_home/workflows/'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof AppHomeWorkflowsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/quotes/': {
      id: '/_app/_home/quotes/'
      path: '/quotes'
      fullPath: '/quotes'
      preLoaderRoute: typeof AppHomeQuotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/pipeline/': {
      id: '/_app/_home/pipeline/'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof AppHomePipelineIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/leads/': {
      id: '/_app/_home/leads/'
      path: '/'
      fullPath: '/leads/'
      preLoaderRoute: typeof AppHomeLeadsIndexRouteImport
      parentRoute: typeof AppHomeLeadsRoute
    }
    '/_app/_home/invoices/': {
      id: '/_app/_home/invoices/'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AppHomeInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/events/': {
      id: '/_app/_home/events/'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AppHomeEventsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_crm/contacts/': {
      id: '/_app/_crm/contacts/'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppCrmContactsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_crm/companies/': {
      id: '/_app/_crm/companies/'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AppCrmCompaniesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/onboarding/organization/$group/$step': {
      id: '/onboarding/organization/$group/$step'
      path: '/$group/$step'
      fullPath: '/onboarding/organization/$group/$step'
      preLoaderRoute: typeof OnboardingOrganizationGroupStepRouteImport
      parentRoute: typeof OnboardingOrganizationRoute
    }
    '/_app/settings_/workflows/new': {
      id: '/_app/settings_/workflows/new'
      path: '/settings/workflows/new'
      fullPath: '/settings/workflows/new'
      preLoaderRoute: typeof AppSettingsWorkflowsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/workflows/$id': {
      id: '/_app/settings_/workflows/$id'
      path: '/settings/workflows/$id'
      fullPath: '/settings/workflows/$id'
      preLoaderRoute: typeof AppSettingsWorkflowsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/quotes/new': {
      id: '/_app/_home/quotes/new'
      path: '/quotes/new'
      fullPath: '/quotes/new'
      preLoaderRoute: typeof AppHomeQuotesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/quotes/$id': {
      id: '/_app/_home/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/quotes/$id'
      preLoaderRoute: typeof AppHomeQuotesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/pipeline/$id': {
      id: '/_app/_home/pipeline/$id'
      path: '/pipeline/$id'
      fullPath: '/pipeline/$id'
      preLoaderRoute: typeof AppHomePipelineIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/leads/$id': {
      id: '/_app/_home/leads/$id'
      path: '/$id'
      fullPath: '/leads/$id'
      preLoaderRoute: typeof AppHomeLeadsIdRouteImport
      parentRoute: typeof AppHomeLeadsRoute
    }
    '/_app/_home/invoices/new': {
      id: '/_app/_home/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AppHomeInvoicesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/invoices/$id': {
      id: '/_app/_home/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AppHomeInvoicesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/events/$id': {
      id: '/_app/_home/events/$id'
      path: '/events/$id'
      fullPath: '/events/$id'
      preLoaderRoute: typeof AppHomeEventsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_crm/contacts/$id': {
      id: '/_app/_crm/contacts/$id'
      path: '/contacts/$id'
      fullPath: '/contacts/$id'
      preLoaderRoute: typeof AppCrmContactsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_crm/companies/new': {
      id: '/_app/_crm/companies/new'
      path: '/companies/new'
      fullPath: '/companies/new'
      preLoaderRoute: typeof AppCrmCompaniesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_crm/companies/$id': {
      id: '/_app/_crm/companies/$id'
      path: '/companies/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof AppCrmCompaniesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/workflows/$id/': {
      id: '/_app/settings_/workflows/$id/'
      path: '/'
      fullPath: '/settings/workflows/$id/'
      preLoaderRoute: typeof AppSettingsWorkflowsIdIndexRouteImport
      parentRoute: typeof AppSettingsWorkflowsIdRoute
    }
    '/_app/settings_/workflows/$id/edit': {
      id: '/_app/settings_/workflows/$id/edit'
      path: '/edit'
      fullPath: '/settings/workflows/$id/edit'
      preLoaderRoute: typeof AppSettingsWorkflowsIdEditRouteImport
      parentRoute: typeof AppSettingsWorkflowsIdRoute
    }
    '/_app/_home/pipeline/$id_/quotes/$quoteId': {
      id: '/_app/_home/pipeline/$id_/quotes/$quoteId'
      path: '/pipeline/$id/quotes/$quoteId'
      fullPath: '/pipeline/$id/quotes/$quoteId'
      preLoaderRoute: typeof AppHomePipelineIdQuotesQuoteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/pipeline/$id_/leads/$leadId': {
      id: '/_app/_home/pipeline/$id_/leads/$leadId'
      path: '/pipeline/$id/leads/$leadId'
      fullPath: '/pipeline/$id/leads/$leadId'
      preLoaderRoute: typeof AppHomePipelineIdLeadsLeadIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/pipeline/$id_/invoices/$invoiceId': {
      id: '/_app/_home/pipeline/$id_/invoices/$invoiceId'
      path: '/pipeline/$id/invoices/$invoiceId'
      fullPath: '/pipeline/$id/invoices/$invoiceId'
      preLoaderRoute: typeof AppHomePipelineIdInvoicesInvoiceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/pipeline/$id_/events/$eventId': {
      id: '/_app/_home/pipeline/$id_/events/$eventId'
      path: '/pipeline/$id/events/$eventId'
      fullPath: '/pipeline/$id/events/$eventId'
      preLoaderRoute: typeof AppHomePipelineIdEventsEventIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_home/pipeline/$id_/events/$eventId_/run-sheet': {
      id: '/_app/_home/pipeline/$id_/events/$eventId_/run-sheet'
      path: '/pipeline/$id/events/$eventId/run-sheet'
      fullPath: '/pipeline/$id/events/$eventId/run-sheet'
      preLoaderRoute: typeof AppHomePipelineIdEventsEventIdRunSheetRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppHomeLeadsRouteChildren {
  AppHomeLeadsIdRoute: typeof AppHomeLeadsIdRoute
  AppHomeLeadsIndexRoute: typeof AppHomeLeadsIndexRoute
}

const AppHomeLeadsRouteChildren: AppHomeLeadsRouteChildren = {
  AppHomeLeadsIdRoute: AppHomeLeadsIdRoute,
  AppHomeLeadsIndexRoute: AppHomeLeadsIndexRoute,
}

const AppHomeLeadsRouteWithChildren = AppHomeLeadsRoute._addFileChildren(
  AppHomeLeadsRouteChildren,
)

interface AppSettingsWorkflowsIdRouteChildren {
  AppSettingsWorkflowsIdEditRoute: typeof AppSettingsWorkflowsIdEditRoute
  AppSettingsWorkflowsIdIndexRoute: typeof AppSettingsWorkflowsIdIndexRoute
}

const AppSettingsWorkflowsIdRouteChildren: AppSettingsWorkflowsIdRouteChildren =
  {
    AppSettingsWorkflowsIdEditRoute: AppSettingsWorkflowsIdEditRoute,
    AppSettingsWorkflowsIdIndexRoute: AppSettingsWorkflowsIdIndexRoute,
  }

const AppSettingsWorkflowsIdRouteWithChildren =
  AppSettingsWorkflowsIdRoute._addFileChildren(
    AppSettingsWorkflowsIdRouteChildren,
  )

interface AppRouteChildren {
  AppBillingSuspendedRoute: typeof AppBillingSuspendedRoute
  AppChatRoute: typeof AppChatRoute
  AppCrmRoute: typeof AppCrmRoute
  AppHomeRoute: typeof AppHomeRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppStartTrialRoute: typeof AppStartTrialRoute
  AppCrmMarketingRoute: typeof AppCrmMarketingRoute
  AppHomeCalendarRoute: typeof AppHomeCalendarRoute
  AppHomeDashboardRoute: typeof AppHomeDashboardRoute
  AppHomeFeedbackRoute: typeof AppHomeFeedbackRoute
  AppHomeInboxRoute: typeof AppHomeInboxRoute
  AppHomeLeadsRoute: typeof AppHomeLeadsRouteWithChildren
  AppHomeReportsRoute: typeof AppHomeReportsRoute
  AppHomeRevenueRoute: typeof AppHomeRevenueRoute
  AppHomeSalesTaxRoute: typeof AppHomeSalesTaxRoute
  AppHomeTasksRoute: typeof AppHomeTasksRoute
  AppSettingsAttachmentLibraryRoute: typeof AppSettingsAttachmentLibraryRoute
  AppSettingsClientPortalRoute: typeof AppSettingsClientPortalRoute
  AppSettingsCommunicationsRoute: typeof AppSettingsCommunicationsRoute
  AppSettingsCompanyRoute: typeof AppSettingsCompanyRoute
  AppSettingsDisputesRoute: typeof AppSettingsDisputesRoute
  AppSettingsEmailRoute: typeof AppSettingsEmailRoute
  AppSettingsEmailSuppressionsRoute: typeof AppSettingsEmailSuppressionsRoute
  AppSettingsFormsRoute: typeof AppSettingsFormsRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsOrganizationRoute: typeof AppSettingsOrganizationRoute
  AppSettingsPaymentsRoute: typeof AppSettingsPaymentsRoute
  AppSettingsServicesRoute: typeof AppSettingsServicesRoute
  AppSettingsStaffRoute: typeof AppSettingsStaffRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppCrmCompaniesIdRoute: typeof AppCrmCompaniesIdRoute
  AppCrmCompaniesNewRoute: typeof AppCrmCompaniesNewRoute
  AppCrmContactsIdRoute: typeof AppCrmContactsIdRoute
  AppHomeEventsIdRoute: typeof AppHomeEventsIdRoute
  AppHomeInvoicesIdRoute: typeof AppHomeInvoicesIdRoute
  AppHomeInvoicesNewRoute: typeof AppHomeInvoicesNewRoute
  AppHomePipelineIdRoute: typeof AppHomePipelineIdRoute
  AppHomeQuotesIdRoute: typeof AppHomeQuotesIdRoute
  AppHomeQuotesNewRoute: typeof AppHomeQuotesNewRoute
  AppSettingsWorkflowsIdRoute: typeof AppSettingsWorkflowsIdRouteWithChildren
  AppSettingsWorkflowsNewRoute: typeof AppSettingsWorkflowsNewRoute
  AppCrmCompaniesIndexRoute: typeof AppCrmCompaniesIndexRoute
  AppCrmContactsIndexRoute: typeof AppCrmContactsIndexRoute
  AppHomeEventsIndexRoute: typeof AppHomeEventsIndexRoute
  AppHomeInvoicesIndexRoute: typeof AppHomeInvoicesIndexRoute
  AppHomePipelineIndexRoute: typeof AppHomePipelineIndexRoute
  AppHomeQuotesIndexRoute: typeof AppHomeQuotesIndexRoute
  AppHomeWorkflowsIndexRoute: typeof AppHomeWorkflowsIndexRoute
  AppSettingsWorkflowsIndexRoute: typeof AppSettingsWorkflowsIndexRoute
  AppHomePipelineIdEventsEventIdRoute: typeof AppHomePipelineIdEventsEventIdRoute
  AppHomePipelineIdInvoicesInvoiceIdRoute: typeof AppHomePipelineIdInvoicesInvoiceIdRoute
  AppHomePipelineIdLeadsLeadIdRoute: typeof AppHomePipelineIdLeadsLeadIdRoute
  AppHomePipelineIdQuotesQuoteIdRoute: typeof AppHomePipelineIdQuotesQuoteIdRoute
  AppHomePipelineIdEventsEventIdRunSheetRoute: typeof AppHomePipelineIdEventsEventIdRunSheetRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBillingSuspendedRoute: AppBillingSuspendedRoute,
  AppChatRoute: AppChatRoute,
  AppCrmRoute: AppCrmRoute,
  AppHomeRoute: AppHomeRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppStartTrialRoute: AppStartTrialRoute,
  AppCrmMarketingRoute: AppCrmMarketingRoute,
  AppHomeCalendarRoute: AppHomeCalendarRoute,
  AppHomeDashboardRoute: AppHomeDashboardRoute,
  AppHomeFeedbackRoute: AppHomeFeedbackRoute,
  AppHomeInboxRoute: AppHomeInboxRoute,
  AppHomeLeadsRoute: AppHomeLeadsRouteWithChildren,
  AppHomeReportsRoute: AppHomeReportsRoute,
  AppHomeRevenueRoute: AppHomeRevenueRoute,
  AppHomeSalesTaxRoute: AppHomeSalesTaxRoute,
  AppHomeTasksRoute: AppHomeTasksRoute,
  AppSettingsAttachmentLibraryRoute: AppSettingsAttachmentLibraryRoute,
  AppSettingsClientPortalRoute: AppSettingsClientPortalRoute,
  AppSettingsCommunicationsRoute: AppSettingsCommunicationsRoute,
  AppSettingsCompanyRoute: AppSettingsCompanyRoute,
  AppSettingsDisputesRoute: AppSettingsDisputesRoute,
  AppSettingsEmailRoute: AppSettingsEmailRoute,
  AppSettingsEmailSuppressionsRoute: AppSettingsEmailSuppressionsRoute,
  AppSettingsFormsRoute: AppSettingsFormsRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsOrganizationRoute: AppSettingsOrganizationRoute,
  AppSettingsPaymentsRoute: AppSettingsPaymentsRoute,
  AppSettingsServicesRoute: AppSettingsServicesRoute,
  AppSettingsStaffRoute: AppSettingsStaffRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppCrmCompaniesIdRoute: AppCrmCompaniesIdRoute,
  AppCrmCompaniesNewRoute: AppCrmCompaniesNewRoute,
  AppCrmContactsIdRoute: AppCrmContactsIdRoute,
  AppHomeEventsIdRoute: AppHomeEventsIdRoute,
  AppHomeInvoicesIdRoute: AppHomeInvoicesIdRoute,
  AppHomeInvoicesNewRoute: AppHomeInvoicesNewRoute,
  AppHomePipelineIdRoute: AppHomePipelineIdRoute,
  AppHomeQuotesIdRoute: AppHomeQuotesIdRoute,
  AppHomeQuotesNewRoute: AppHomeQuotesNewRoute,
  AppSettingsWorkflowsIdRoute: AppSettingsWorkflowsIdRouteWithChildren,
  AppSettingsWorkflowsNewRoute: AppSettingsWorkflowsNewRoute,
  AppCrmCompaniesIndexRoute: AppCrmCompaniesIndexRoute,
  AppCrmContactsIndexRoute: AppCrmContactsIndexRoute,
  AppHomeEventsIndexRoute: AppHomeEventsIndexRoute,
  AppHomeInvoicesIndexRoute: AppHomeInvoicesIndexRoute,
  AppHomePipelineIndexRoute: AppHomePipelineIndexRoute,
  AppHomeQuotesIndexRoute: AppHomeQuotesIndexRoute,
  AppHomeWorkflowsIndexRoute: AppHomeWorkflowsIndexRoute,
  AppSettingsWorkflowsIndexRoute: AppSettingsWorkflowsIndexRoute,
  AppHomePipelineIdEventsEventIdRoute: AppHomePipelineIdEventsEventIdRoute,
  AppHomePipelineIdInvoicesInvoiceIdRoute:
    AppHomePipelineIdInvoicesInvoiceIdRoute,
  AppHomePipelineIdLeadsLeadIdRoute: AppHomePipelineIdLeadsLeadIdRoute,
  AppHomePipelineIdQuotesQuoteIdRoute: AppHomePipelineIdQuotesQuoteIdRoute,
  AppHomePipelineIdEventsEventIdRunSheetRoute:
    AppHomePipelineIdEventsEventIdRunSheetRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface OnboardingOrganizationRouteChildren {
  OnboardingOrganizationIndexRoute: typeof OnboardingOrganizationIndexRoute
  OnboardingOrganizationGroupStepRoute: typeof OnboardingOrganizationGroupStepRoute
}

const OnboardingOrganizationRouteChildren: OnboardingOrganizationRouteChildren =
  {
    OnboardingOrganizationIndexRoute: OnboardingOrganizationIndexRoute,
    OnboardingOrganizationGroupStepRoute: OnboardingOrganizationGroupStepRoute,
  }

const OnboardingOrganizationRouteWithChildren =
  OnboardingOrganizationRoute._addFileChildren(
    OnboardingOrganizationRouteChildren,
  )

interface OnboardingRouteChildren {
  OnboardingOrganizationRoute: typeof OnboardingOrganizationRouteWithChildren
  OnboardingUserRoute: typeof OnboardingUserRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingOrganizationRoute: OnboardingOrganizationRouteWithChildren,
  OnboardingUserRoute: OnboardingUserRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  MagicLinkRoute: MagicLinkRoute,
  OauthSuccessRoute: OauthSuccessRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  SetPasswordRoute: SetPasswordRoute,
  SignupRoute: SignupRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  OauthConsentRoute: OauthConsentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
